import { createStore } from 'zustand/vanilla';

export interface ReverificationState {
  eulaAgree: boolean;
  privacyAgree: boolean;
  isSubscribeMarketingEvent: boolean;
  setAllAgree: (check: boolean) => void;
  setEulaAgree: (check: boolean) => void;
  setPrivacyAgree: (check: boolean) => void;
  setSubscribeMarketingEvent: (check: boolean) => void;
}

export const createReverificationStore = () =>
  createStore<ReverificationState>((set) => ({
    eulaAgree: false,
    privacyAgree: false,
    isSubscribeMarketingEvent: false,
    setAllAgree: (check) =>
      set({ eulaAgree: check, privacyAgree: check, isSubscribeMarketingEvent: check }),
    setEulaAgree: (check) => set({ eulaAgree: check }),
    setPrivacyAgree: (check) => set({ privacyAgree: check }),
    setSubscribeMarketingEvent: (check) => set({ isSubscribeMarketingEvent: check }),
  }));

export type ReverificationStoreApi = ReturnType<typeof createReverificationStore>;

export const selectIsRequiredAllAgree = (s: ReverificationState): boolean =>
  s.eulaAgree && s.privacyAgree;

export const selectIsAllAgree = (s: ReverificationState): boolean =>
  selectIsRequiredAllAgree(s) && s.isSubscribeMarketingEvent;
